<template>
  <o-form-group :label="label">
    <o-file-upload-control v-model="localValue" :allow-clear="allowClear" :allow-download="allowDownload" :accept="accept"></o-file-upload-control>
  </o-form-group>
</template>

<script>
  export default {
    name: 'o-file-upload',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      allowClear: {
        type: Boolean,
        default: true
      },
      allowDownload: {
        type: Boolean,
        default: true
      },
      accept: {
        type: String
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
